import React from 'react';


const AlternatePicker = ({ selectedDay, selectedMonth, selectedYear, selectedHour, selectedMinute, restaurantName, allOccasions, phone, options, selectedArea, onVenueChange, onAreaChange, onChangeToEnquiry }) => {

    const formatPhoneNumber = (phone) => {
        phone = phone.toString().replace("+", "").replace("44", "0")
        var phoneSplit = [phone.substring(0, 3), phone.substring(3, 7), phone.substring(7, 11)];
        var formattedNumber = phoneSplit.join(' ');
        return formattedNumber;
    }

    const makeEnquiryValid = () => {
        var now = new Date();
        if (now.getDate() == selectedDay && now.getMonth() == selectedMonth && now.getFullYear() == selectedYear) {
            return false;
        }
        var enquiryOption = allOccasions.filter(o => o.areaLinkGroup.areaLinks[0] && o.areaLinkGroup.areaLinks[0].id == selectedArea.areaLinkGroup.areaLinks[0].id && o.name.indexOf('Enquiry') != -1);
        if (enquiryOption.length == 0) {
            return false;
        }
        return true;
    }

    const getTimeSlots = () => {
        var slotList = [];
        var thisVenue = options[0];
        var indexToFind = Number(selectedHour + selectedMinute);
        var thisSlotIndex = thisVenue.availability.findIndex(s => s.time == indexToFind);
        //If we didn't find an index, try the first or last of the availability object
        if(thisSlotIndex == -1 && thisVenue.availability.length && thisVenue.availability[0].time > indexToFind) {
            thisSlotIndex = 0;
        } else if(thisSlotIndex == -1 && thisVenue.availability.length && thisVenue.availability[thisVenue.availability.length - 1].time < indexToFind) {
            thisSlotIndex = thisVenue.availability.length - 1;
        }
        
        var thisSlot = thisVenue.availability[thisSlotIndex];
        if (thisSlot) {
            slotList.push(thisSlot);
        }
        else {
            thisSlotIndex = 0;
        }

        var lastSlotIndex = thisVenue.availability.length - 1;

        for (let i = 1; i <= 6 && i <= thisSlotIndex; i++) {
            slotList.unshift(thisVenue.availability[thisSlotIndex - i]);
        }

        for (let i = 1; i <= 5 && thisSlotIndex + i <= lastSlotIndex; i++) {
            slotList.push(thisVenue.availability[thisSlotIndex + i]);
        }
        return slotList;
    }

    const getAlternateAreaTimeSlots = () => {
        var originalVenueName = options[0].restaurantName;
        var venueList = [];
        for (let i = 1; i < options.length; i++) {
            if (options[i].restaurantName === originalVenueName) {
                var venue = {};
                venue.restaurantName = options[i].restaurantName;
                venue.address = options[i].address;
                venue.liveresId = options[i].liveresId;
                venue.slotList = [];
                venue.areaName = options[i].areaName;
                var thisSlotIndex = options[i].availability.findIndex(s => s.time == selectedHour + selectedMinute);
                if (thisSlotIndex >= 0) {
                    var thisSlot = options[i].availability[thisSlotIndex];
                    thisSlot.liveresId = options[i].liveresId;
                    venue.slotList.push(thisSlot);
                }
                else {
                    thisSlotIndex = 0;
                }
                var lastSlotIndex = options[i].availability.length - 1;
                for (let j = 1; j <= 6 && thisSlotIndex - j >= 0; j++) {
                    venue.slotList.unshift(options[i].availability[thisSlotIndex - j]);
                }

                for (let k = 1; k <= 5 && thisSlotIndex + k <= lastSlotIndex; k++) {
                    venue.slotList.push(options[i].availability[thisSlotIndex + k]);
                }

                venueList.push(venue);
            }
        }
        return venueList;
    }

    const getAlternateVenues = () => {
        var originalVenueName = options[0].restaurantName;
        var venueList = [];
        for (let i = 1; i < options.length; i++) {
            if (options[i].restaurantName !== originalVenueName) {
                var venue = {};
                venue.restaurantName = options[i].restaurantName;
                venue.address = options[i].address;
                venue.phone = options[i].phone;
                venue.liveresId = options[i].liveresId;
                venue.link = "/restaurants/" + options[i].restaurantName.replaceAll(" ", "-").toLowerCase();
                venue.image = options[i].imageUrl
                venue.slotList = [];
                var thisSlotIndex = options[i].availability.findIndex(s => s.time == selectedHour + selectedMinute);
                if (thisSlotIndex >= 0) {
                    var thisSlot = options[i].availability[thisSlotIndex];
                    thisSlot.liveresId = options[i].liveresId;
                    venue.slotList.push(thisSlot);
                } else {
                    thisSlotIndex = 0;
                }
                var lastSlotIndex = options[i].availability.length - 1;
                for (let j = 1; j <= 2 && thisSlotIndex - j >= 0; j++) {
                    venue.slotList.unshift(options[i].availability[thisSlotIndex - j]);
                }

                var slotsNeeded = 4 - venue.slotList.length;

                for (let k = 1; k <= slotsNeeded && thisSlotIndex + k <= lastSlotIndex; k++) {
                    venue.slotList.push(options[i].availability[thisSlotIndex + k]);
                }

                if (venue.slotList.filter(v => v.available).length > 0) {
                    venueList.push(venue);
                }
            }


        }

        return venueList;
    }

    const EnquiryConversionAvailable = () => {
        var enquiryOption = allOccasions.filter(o => o.areaLinkGroup.areaLinks[0] && o.areaLinkGroup.areaLinks[0].id == selectedArea.areaLinkGroup.areaLinks[0].id && o.name.indexOf('Enquiry') != -1);
        if (enquiryOption) return true;

        return false;

    }

    const convertToEnquiry = () => {
        var enquiryOption = allOccasions.filter(o => o.areaLinkGroup.areaLinks[0] && o.areaLinkGroup.areaLinks[0].id == selectedArea.areaLinkGroup.areaLinks[0].id && o.name.indexOf('Enquiry') != -1);
        if (enquiryOption.length == 0) {
            console.error('Can not find Enquiry Occasion for Area ' + selectedArea.areaLinkGroup.areaLinks[0].id);
        }
        else {
            onChangeToEnquiry(enquiryOption.id);
        }
    }

    const thisVenueSlots = getTimeSlots();

    return (
        <React.Fragment>
            <div className='p-4 w-full bg-tomato text-off-white mt-5'>
                <div className='flex gap-2 justify-center'>
                    <div className="box-icon items-center flex">
                        <img src="/icons/common/offwhite/alert-circle.svg" alt="alert" />
                    </div>
                    <div className='mb-0 text-center'>Sorry, your preferred time isn't available, here are some other options though</div>
                </div>
            </div>
            {(!!thisVenueSlots.length) && (
                <>
                    <div className="title align-left mt-7 before:mb-5">
                        <h5 className="subtitle">Available times at Jamie's Italian {restaurantName}</h5>
                    </div>
                    <div className='grid max-lg:grid-cols-4 lg:grid-cols-5 gap-4'>
                        {thisVenueSlots.map((s, i) => (
                            <div key={i} className="w-full">
                                <button disabled={!s.available} className={`button w-full ${s.available ? "button-secondary" : "crossed"}`} onClick={() => onVenueChange(s.time, null, null, null)}>
                                    {s.time.toString().slice(0, 2) + ':' + s.time.toString().slice(2)}
                                </button>
                            </div>
                        ))}
                    </div>
                    <hr />
                </>)}

            {options.length > 1 &&
                <>
                    {/* Check that there are other available areas in the same venue */}
                    

                    {getAlternateAreaTimeSlots().map((v, i) => (
                        <div key={v.restaurantName + i}>
                            <div key={v.restaurantName + i} className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 pb-5">

                                {v.image && <div className='md:grid-cols-1 lg:col-span-2'>
                                    <div className='aspect-[7/4] overflow-hidden'>
                                        <img className='object-cover' src={v.image} alt={v.restaurantName} />
                                    </div>
                                </div>}
                                <div className={`${v.image ? 'md:col-span-2 lg:col-span-3' : 'md:col-span-3 lg:col-span-5'}`}>
                                    <div>
                                        {restaurantName === options[1].restaurantName && <div className="title align-left mt-7 before:mb-5">
                                            <h5 className="subtitle">Would you like to try {v.areaName} at {restaurantName}?</h5>
                                        </div>}
                                        <p>Please select a time to book a table</p>
                                        <div className='grid grid-cols-4 gap-4'>
                                            {v.slotList.map((s, i) => (
                                                <div key={i} className="w-full">
                                                    <button disabled={!s.available} className={`button w-full ${s.available ? "button-secondary" : "disabled crossed"}`} onClick={() => {
                                                        onAreaChange(s.time, v.areaName)
                                                    }}>
                                                        {s.time.toString().slice(0, 2) + ':' + s.time.toString().slice(2)}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    <hr />
                </>}

            {getAlternateVenues().length > 0 &&
                <div className="title align-left mt-4 before:mb-5">
                    <h5 className="subtitle">Other Jamie's Italian locations you might like:</h5>
                </div>
            }

            {getAlternateVenues().map((v, i) => (
                <div key={v.restaurantName + i} className='pb-5'>
                    <div key={v.restaurantName + i} className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">

                        {v.image && <div className='md:grid-cols-1 lg:col-span-2'>
                            <div className='aspect-[7/4] overflow-hidden'>
                                <img className='object-cover' src={v.image} alt={v.restaurantName} />
                            </div>
                        </div>}
                        <div className={`${v.image ? 'md:col-span-2 lg:col-span-3' : 'md:col-span-3 lg:col-span-5'}`}>
                            <div>
                                {v.restaurantName && <h4 className='mb-2'>{v.restaurantName}</h4>}
                                {v.address && <p>{v.address}</p>}
                                <div className="flex gap-4 items-center">
                                    {v.phone && <a href={'tel:' + v.phone.toString().replace("+", "").replace("44", "0")} className='flex items-center justify-center gap-2 text-basil'>
                                        <div className='box-icon w-5 h-5'>
                                            <img alt="phone icon" className="icon" src="/icons/restaurants/phone-call.svg" />
                                        </div>
                                        <div className='underline'>{formatPhoneNumber(v.phone)}</div>
                                    </a>}
                                    {v.link && <div><a className='link uppercase' href={v.link}>VIEW RESTAURANT</a></div>}
                                </div>
                            </div>
                            <div className='pt-4'>
                                <p className='subtitle mb-0 text-lg'>Available times</p>
                                <p>Please select a time to book a table</p>
                                <div className='grid grid-cols-4 gap-4'>
                                    {v.slotList.map((s, i) => (
                                        <div key={i} className="w-full">
                                            <button disabled={!s.available} className={`button w-full ${s.available ? "button-secondary" : "disabled crossed"}`} onClick={() => {
                                                onVenueChange(s.time, v.restaurantName, v.address, v.liveresId)
                                            }}>
                                                {s.time.toString().slice(0, 2) + ':' + s.time.toString().slice(2)}
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='bg-sage h-px w-full my-5'></div>
                </div>
            ))}

            <div className='flex justify-center gap-2 text-basil text-lg mt-12'>
                <span>Or call Jamie's Italian {restaurantName} on </span>

                <a href={'tel:' + phone.toString().replace("44", "0")} className='flex gap-2 items-center'>
                    <div className='box-icon w-5 h-5'>
                        <img alt="phone icon" className="icon" src="/icons/restaurants/phone-call.svg" />
                    </div>
                    <div>
                        {formatPhoneNumber(phone)}
                    </div>
                </a>
            </div>

            {makeEnquiryValid() &&
                <div>
                    <span>If you'd rather be contacted by a member of our team, please submit an enquiry using the button below.</span>
                    <div className="mt-6 flex justify-center">
                        <button className="button" onClick={convertToEnquiry}>Make an Enquiry</button>
                    </div>
                </div>
            }


        </React.Fragment>);

}

export default AlternatePicker;